import { createSvgComponent } from "../../icon/createSvgComponent";
import CameraFill from "@core/__generated__/icon/figma/camera-fill.svg";
export default createSvgComponent(CameraFill);